:host {
  display: block;
}

slot::slotted(aha-image-selector) {
  border-top: 1px solid var(--theme-primary-border);
}
